var pageId = '';

pageId = $('body').attr('id');
switch (pageId) {

	//body id='top'
	case 'top':
		require('./top.ts');
	break;

	//body id='map'
	case 'map':

	break;
}

//common
require('./anime.ts');

$(function() {
	$(window).on('load scroll', function() {
		var scrollPos = $(this).scrollTop();
		if ( scrollPos > 50 ) {
			$('header').addClass('h-small');
		} else {
			$('header').removeClass('h-small');
		}
	});
});


$('.g_menu_btn').on('click',function(){
	$(this).toggleClass('active');
	$('.g_nav').toggleClass('active');
	$('header').toggleClass('active');
});

//---------scroll-prp----------//
$(function(){
	 $('a[href^="#"]').click(function() {
		 var speed = 400;
		 var href= $(this).attr("href");
		 var target = $(href == "#" || href == "" ? 'html' : href);
		 var position = target.offset().top;
		 $('body,html').animate({scrollTop:position}, speed, 'swing');
		 return false;
	 });
 });

 //---------scroll-btn----------//
 $(window).on("scroll",function(){
	 scrollHeight = $(document).height();
	 scrollPosition = $(window).height() + $(window).scrollTop();
	 footerHeight = $("footer").innerHeight();
	 if(scrollHeight - scrollPosition <= footerHeight){
		 $(".top-scroll").css({
			 "position":"absolute",
			 "bottom":footerHeight
		 });
	 }else{
		 $(".top-scroll").css({
			 "position":"fixed",
			 "bottom":"0"
		 });
	 }
 });
